import { Pipe, PipeTransform } from '@angular/core';

import { ClassificacaoAgrupamentoPorTipoClassificacao } from '../classificacao-agrupamento-por-tipo-classificacao';

@Pipe({
    name: 'classificacaoAgrupamentoNivelTipoClassificacaoFilter',
    pure: false
})
export class ClassificacaoAgrupamentoNivelTipoClassificacaoFilterPipe implements PipeTransform {
    /** Filtra os agrupamentos das classificações pelo nível do seu tipo de classificação */
    transform(entities: ClassificacaoAgrupamentoPorTipoClassificacao[], nivel: number = null): ClassificacaoAgrupamentoPorTipoClassificacao[] {
        if (!entities) {
            return [];
        }
        // Retorna todas as classificações quando não for informado um nível para filtar
        if (!nivel) {
            return entities;
        }

        return entities.filter(entityFilter => entityFilter.nivelTipoClassificacao === nivel);
    }
}
